<template>
  <div class="bg-quickstart-purple p-4 w-full rounded-lg mb-6 border border-gray-200">
    <Card class="bg-transparent border-none shadow-none text-white">
      <CardHeader>
        <CardTitle>
          <slot name="header" />
        </CardTitle>
        <CardDescription>
          <slot name="body" />
        </CardDescription>
      </CardHeader>
    </Card>
  </div>
</template>

<script>
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import introJs from 'intro.js';
import 'intro.js/introjs.css';

export default {
  components: {
    Card,
    CardContent,
    CardHeader,
    CardTitle,
  },
  mounted() {
    setTimeout(() => {
      introJs('#app').addHints();
      introJs('#app').start();
    }, 1000);
  },
};
</script>
